<script setup lang="ts">
// COMPONENTS
import { GSkeleton, GSkeletonItem } from '@flash-global66/g-skeleton';

/**
 * Líneas del menú lateral mientras carga su configuración. Mismo alto (44px) y paso
 * (64px) que los ítems de `MenuRoute`, para que el menú real aparezca en su lugar.
 */
defineOptions({ name: 'SidebarMenuSkeleton' });
</script>

<template>
  <GSkeleton
    animated
    aria-hidden="true"
    data-test="layout:sidebar-menu-skeleton"
    class="flex flex-col gap-5"
  >
    <template #template>
      <GSkeletonItem
        v-for="item in 8"
        :key="item"
        variant="rect"
        class="h-11 w-full rounded-lg"
      />
    </template>
  </GSkeleton>
</template>
